

















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class ExclamationIcon extends Vue {
  @Prop({ default: '10' }) readonly size!: string|number;
  @Prop(Boolean) readonly fillCurrentColor!: boolean;
}
